import "./index.css";
import { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import AppLoadingView from "./components/loaders/AppLoadingView";
import SuspenseFallback from "./components/loaders/SuspenseFallback";
import App from "./core/App";
import { i18nReady } from "./i18n";
import reportWebVitals from "./reportWebVitals";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
		},
	},
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// Show the loading view until translations are available, so that labels never render as raw keys.
root.render(<AppLoadingView />);

i18nReady.finally(() => {
	root.render(
		<QueryClientProvider client={queryClient}>
			<Suspense fallback={<SuspenseFallback />}>
				<App />
			</Suspense>
		</QueryClientProvider>
	);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
